const pid = {
  'pid.input.empty': 'Empty field',
  'pid.DIA_NASCIMENTO': 'Birthday day',
  'pid.MES_NASCIMENTO': 'Birthday month',
  'pid.ANO_NASCIMENTO': 'Birthday year',
  'pid.CPF': 'CPF',
  'pid.CEP_RESIDENCIAL': 'Zipcode',
  'pid.RG': 'RG',
  'pid.ESTADO_CIVIL': 'Marital Status',
  'pid.PRIMEIRO_NOME_MAE': "Mother's first name",
  'pid.verifyAnswers': 'Verify answers before send',
  'pid.question': 'Question',
  'pid.send': 'Save',
  'pid.continue': 'Continue',
  'pid.restart': 'Restart',
  'pid.submit.success': 'Confirmation identification success',
  'pid.submit.error': 'Attention! Wrong answers',
  'pid.submit.expired':
    'Positive Identification expired. Please start over again',
};

export default pid;
